import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Use withCredentials globally so cookies are sent for auth
export const api = axios.create({ baseURL: API, timeout: 60000, withCredentials: true });

export const createInvitation = (data) => api.post("/invitations", data).then((r) => r.data);
export const listInvitations = () => api.get("/invitations").then((r) => r.data);
export const getInvitation = (id) => api.get(`/invitations/${id}`).then((r) => r.data);
export const getInvitationBySlug = (slug) => api.get(`/invitations/slug/${slug}`).then((r) => r.data);
export const getInvitationByPreviewToken = (token) => api.get(`/invitations/preview/${token}`).then((r) => r.data);
export const updateInvitation = (id, data) => api.patch(`/invitations/${id}`, data).then((r) => r.data);
export const deleteInvitation = (id) => api.delete(`/invitations/${id}`).then((r) => r.data);
export const submitRsvp = (invId, data) => api.post(`/invitations/${invId}/rsvp`, data).then((r) => r.data);
export const listRsvps = (invId) => api.get(`/invitations/${invId}/rsvps`).then((r) => r.data);
export const generateImage = (payload) => api.post("/generate-image", payload, { timeout: 120000 }).then((r) => r.data);
export const generateSticker = (payload) => api.post("/generate-sticker", payload, { timeout: 120000 }).then((r) => r.data);

// Guestbook
export const addGuestbookEntry = (invId, data) => api.post(`/invitations/${invId}/guestbook`, data).then((r) => r.data);
export const listGuestbook = (invId) => api.get(`/invitations/${invId}/guestbook`).then((r) => r.data);
// Playlist
export const addPlaylistSong = (invId, data) => api.post(`/invitations/${invId}/playlist`, data).then((r) => r.data);
export const listPlaylist = (invId) => api.get(`/invitations/${invId}/playlist`).then((r) => r.data);

// Admin (only for accounts listed in ADMIN_EMAILS on the backend)
export const adminOverview = () => api.get("/admin/overview").then((r) => r.data);

// Site contact settings (Instagram / WhatsApp)
export const getContactSettings = () => api.get("/settings/contact").then((r) => r.data);
export const updateContactSettings = (data) => api.put("/admin/settings/contact", data).then((r) => r.data);
